<template>
    <div>Logging out...</div>
</template>
<script>
    export default {
        name: 'logout',
        created () {
            this.$auth.logout()
        }
    }
</script>


// WEBPACK FOOTER //
// Logout.vue?b770a8d8